import web from "../web";

class TranchesscolaritesService {
    index(token){
        return web.get("/api/tranchesscolarites", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/tranchesscolarites", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/tranchesscolarites/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/tranchesscolarites/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/tranchesscolarites/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new TranchesscolaritesService()